import { t } from '!/i18n'
import {
  PriceSettingsAvailabilityPeriodTimeUnit,
  PriceSettingsType as PriceSettingsTypeEnum,
  type FormattedPriceSettings,
} from '@setplex/tria-api'
import type { IPriceSettingsTranslatedText } from './index.h'

export const getStringUnitOfTime = ({
  availabilityPeriodTimeUnit,
  availabilityPeriodLength,
  t,
}: Exclude<IPriceSettingsTranslatedText, 'type'>): string => {
  const options = { count: availabilityPeriodLength }
  switch (availabilityPeriodTimeUnit) {
    case PriceSettingsAvailabilityPeriodTimeUnit.Year:
      return t('year', { ...options })
    case PriceSettingsAvailabilityPeriodTimeUnit.Month:
      return t('month', { ...options })
    case PriceSettingsAvailabilityPeriodTimeUnit.Day:
      return t('day_count', {
        ...options,
      })
    default:
      return ''
  }
}

export const getPriceSettingsTranslatedText = ({
  t,
  type,
  availabilityPeriodTimeUnit,
  availabilityPeriodLength,
}: IPriceSettingsTranslatedText): string => {
  const timeUnit = getStringUnitOfTime({
    availabilityPeriodTimeUnit,
    availabilityPeriodLength,
    t,
  })
  switch (type) {
    case PriceSettingsTypeEnum.Purchase:
      return t('purchased_text')
    case PriceSettingsTypeEnum.Rent: {
      return t('rented_text_web', {
        period: timeUnit,
      })
    }
    default:
      return ''
  }
}

export const formatPriceSettings = (
  priceSettings?: FormattedPriceSettings | null
): FormattedPriceSettings | null => {
  if (!priceSettings) return null
  const { type, availabilityPeriodTimeUnit, availabilityPeriodLength } =
    priceSettings

  const text = getPriceSettingsTranslatedText({
    t,
    type,
    availabilityPeriodTimeUnit,
    availabilityPeriodLength,
  })
  return { ...priceSettings, text }
}
